import React from "react";
import ReactDom from "react-dom";
import Classnames from "classnames";
import PropTypes from "prop-types";

import "./index.scss";

export default class Modal extends React.Component {
	static propTypes = {
		children: PropTypes.node,
		className: PropTypes.string,
		close: PropTypes.func,
		toggle: PropTypes.bool
	}
	static defaultProps = {
		children: null,
		className: "",
		closeFn: null,
		toggle: false
	}
	render() {
		const { children, className, close, toggle } = this.props;
		const portal = ReactDom.createPortal(
			<div className="modal-component pf fullscreen" onClick={close}>
				<div className={Classnames("abs-ct", className)} onClick={e => e.stopPropagation()}>{children}</div>
			</div>,
			document.getElementById("root")
		);
		return toggle ? portal : null;
	}
}